import { Box, Grid } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { useNonDeerRouteDetails } from 'Deer/hooks/useNonDeerRouteDetails';
import { useRouteToNavLevels } from 'Deer/hooks/useRouteToL3';
import { useSelectIsL2Visible } from 'Deer/slice/DeerNav.slice';

import { isMobileView } from 'constants/isMobileView';
import { isNetchexLogin } from 'constants/netChexConstants';

import { NetchexPrimaryNav } from './primary/NetchexPrimaryNav';
import { PrimaryNav } from './primary/PrimaryNav';
import SecondaryNav from './secondary';
import { SecondaryNavNonDeer } from './secondary/SecondaryNavNonDeer';

const LeftNavContainerGrid = styled(Grid)`
  /* L1 nav is 80px wide and L2 nav is 240px wide */
  display: flex;
`;

const LeftNav = () => {
  const { l1Module } = useRouteToNavLevels();
  const matchedNonDeerRoute = useNonDeerRouteDetails();
  // const dispatch = useDispatch();
  const isMobileViewBool = isMobileView();

  const showSecondaryNav = (!isMobileViewBool && Boolean(l1Module)) || matchedNonDeerRoute?.hasSidePanel;

  const isL2NavVisible = useSelectIsL2Visible();

  const hasNonDeerSidepanel = matchedNonDeerRoute?.hasSidePanel;

  const isMyDataModule = l1Module === 'myData';

  return (
    <LeftNavContainerGrid>
      {isNetchexLogin && !hasNonDeerSidepanel && isMyDataModule && (
        <Box style={{ flex: '0 0 5rem' }}>
          <NetchexPrimaryNav />
        </Box>
      )}
      {!isMobileViewBool && !isNetchexLogin && (
        <Box style={{ flex: '0 0 5rem' }}>
          <PrimaryNav />
        </Box>
      )}

      {showSecondaryNav && !isNetchexLogin && (
        <Box
          style={{
            flex: isMobileViewBool ? `0 0 100%` : isL2NavVisible ? `0 0 16rem` : '0',
            width: isL2NavVisible ? '16rem' : '33px',
          }}
        >
          {hasNonDeerSidepanel ? <SecondaryNavNonDeer /> : <SecondaryNav />}
        </Box>
      )}
      {isNetchexLogin && showSecondaryNav && hasNonDeerSidepanel && <SecondaryNavNonDeer />}
    </LeftNavContainerGrid>
  );
};

export default LeftNav;
